interface QueryStringParam {
    value: string;
    presentKey: string;
}

export class QueryString {
    params: Record<string, QueryStringParam>;

    constructor(queryString?: string | Record<string, unknown>) {
        this.params = {};
        if (!queryString) return;

        try {
            const searchParams = typeof queryString === 'object' ? queryString : QueryString.parseQueryString(queryString);

            for (const entry of Object.keys(searchParams)) {
                if (entry[0] && entry[0].length > 0) {
                    this.set(entry, searchParams[entry] as string);
                }
            }
        } catch (error) {
            // do nothing
        }
    }

    toString(): string {
        return Object.keys(this.params)
            .filter((key) => this.params[key].value)
            .map((key) => `${this.params[key].presentKey}=${this.params[key].value}`)
            .join('&');
    }

    have(key: string): boolean {
        return this.get(key) !== null;
    }

    get(key: string) {
        const param = this.params[key.toLowerCase()];
        return param ? param.value : null;
    }

    set(key: string, value: string) {
        this.params[key.toLowerCase()] = {
            value,
            presentKey: key,
        };
        return this;
    }

    delete(...keys: string[]) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        keys.forEach((key) => delete this.params[key.toLowerCase()]);
    }

    static parseQueryString(queryString: string): Record<string, string> {
        // Check if the queryString is not empty or undefined
        if (!queryString) {
            return {};
        }

        // Remove the leading '?' if present
        const tempQueryString = queryString.startsWith('?') ? queryString.slice(1) : queryString;

        // Split the queryString into individual key-value pairs
        const pairs = tempQueryString.split('&');

        // Reduce the pairs into a single object (Record<string, string>)
        const queryRecord = pairs.reduce<Record<string, string>>((accumulator, currentValue) => {
            // Split the pair into key and value
            const key = currentValue.substring(0, currentValue.indexOf('='));
            let value = currentValue.substring(key.length + 1);

            try {
                value = decodeURIComponent(value);
            } catch (error) {
                // This case should never happen with newer browsers.
                // This code converts legacy encoded unicode (example '%u300c') to '\u300c' format
                value = value.startsWith('%u') ? String.fromCharCode(parseInt(value.replace('%u', ''), 16)) : value;
            }

            if (key && value) {
                accumulator[key] = decodeURIComponent(value);
            }
            return accumulator;
        }, {});

        return queryRecord;
    }
}
